<template>
  <div class="live-message">
    <ul>
      <li v-for="(item, index) in datas" :key="`message_item_${index}`">
        <!-- 文本消息 -->
        <template v-if="item.userAction === 1">
          <div class="live-message-item live-message-text">
            <div class="pic"><img :src="getImageUrl(item.headPic,'?imageView2/1/w/60/h/60', './static/img/header_user.png')" /></div>
            <div class="content">
              <div class="inner">
                <h4>{{item.nickName}}</h4>
                <p>{{item.msg}}</p>
              </div>
            </div>
          </div>
        </template>
        <!-- 加入直播间，自己加入直播间的消息可以看到 -->
        <template v-if="item.isSend && item.userAction === 2">
          <div class="live-message-item live-message-notify">
            <div class="pic"></div>
            <div class="content">
              <div class="inner">
                <p>{{item.nickName}}加入了直播间</p>
              </div>
            </div>
          </div>
        </template>
        <!-- 退出直播间，自己退出直播间的消息可以看到 -->
        <template v-if="item.isSend && item.userAction === 3">
          <div class="live-message-item live-message-notify">
            <div class="pic"></div>
            <div class="content">
              <div class="inner">
                <p>{{item.nickName}}离开了直播间</p>
              </div>
            </div>
          </div>
        </template>
        <!-- 点赞 -->
        <template v-if="item.userAction === 4 && item.msg === 'show'">
          <div class="live-message-item live-message-notify">
            <div class="pic"></div>
            <div class="content">
              <div class="inner">
                <p>{{item.nickName}}给主播送了花</p>
              </div>
            </div>
          </div>
        </template>
        <!-- 系统消息 -->
        <template v-if="item.userAction === 1001 || item.userAction === 1002 || item.userAction === 1003">
          <div class="live-message-item live-message-notify">
            <div class="pic"></div>
            <div class="content">
              <div class="inner">
                <p v-if="item.userAction === 1001">主播开始直播啦~</p>
                <p v-if="item.userAction === 1002">主播已经离开了直播间</p>
                <p v-if="item.userAction === 1003">{{item.msg}}</p>
              </div>
            </div>
          </div>
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
import { getImageUrl } from '@/utils/utils'
export default {
  name: 'LiveMessage',
  props: {
    datas: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    getImageUrl
  },
  watch: {
    datas: {
      handler(val, oldVal) {
        this.$nextTick(function() {
          this.$emit('update')
        })
      },
      deep: true
    }
  }
}
</script>
<style>
.live-message-item {
  display: flex;
  margin: 0 12px 8px;
}
.live-message-item .pic {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
}
.live-message-item .pic img {
  width: 100%;
  height: 100%;
}
.live-message-item .content {
  flex: 1;
  margin: 0 10px;
}
.live-message-item .inner {
  position: relative;
  display: inline-block;
  max-width: 80%;
  min-height: 30px;
  padding: 6px 8px;
}
.live-message-item .inner p {
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
/* 文本消息 */
.live-message-text .inner {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.live-message-text .inner::before {
  position: absolute;
  content: '';
  left: -5px;
  top: 11px;
  border-top: 4px solid transparent;
  border-right: 5px solid rgba(0, 0, 0, 0.3);
  border-bottom: 4px solid transparent;
}
.live-message-text .inner h4 {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 4px;
  color: #fff;
}
/* 通知消息 */
.live-message-notify .inner {
  background: rgba(60, 163, 241, 0.3);
  border-radius: 4px;
}
.live-message-notify .inner::before {
  position: absolute;
  content: '';
  left: -5px;
  top: 11px;
  border-top: 4px solid transparent;
  border-right: 5px solid rgba(60, 163, 241, 0.3);
  border-bottom: 4px solid transparent;
}
.live-message-notify .pic {
  background: url('../../assets/img/live_notify_icon.png') no-repeat;
  background-size: contain;
}
</style>
